import { all } from "redux-saga/effects";
import invoiceRootSaga from "./invoice-root-saga";
import generalRootSaga from "./general-root-saga";
import customerRootSaga from "./customer-root-saga";
import productRootSaga from "./product-root-saga";
import storeRootSaga from "./store-root-saga";
import { storeViewWatcher } from "../store-saga";
import authRootSaga from "./auth-saga";
import userRootSaga from "./user-root-saga";
import adminCustomerRootSaga from "./admin-customer-root-saga";
import discountRootSaga from "./discount-root-saga";
import inventoryRootSaga from "./inventory-root-saga";
import salesRootSaga from "./sales-root-saga";
import purchaseRootSaga from "./purchase-root-saga";
import financialRootSaga from "./financial-root-saga";
import settingsRootSaga from "./settings-root-saga";
import doctorRootSaga from "./doctor-root-saga";
import reportRootSaga from "./report-root-saga";
import dashboardRootSaga from "./dashboard-root-saga";
import stockAuditRootSaga from "./stock-details-audit";
import alertRootSaga from "./alert-root-saga";
import regionalRestrictionsRootSaga from "./regional-restrictions-root-saga";
import customReportRootSaga from "./custom-report-root-saga";
import customFunctionRootSaga from "./custom-function-root-saga";
import approvalWorkFlowRootSaga from "../approval-workflow-root-saga";
import loyaltyRootSaga from "./loyalty-root-saga";
import schemeRootSaga from "./scheme-root-saga";
import couponRootSaga from "./coupon-root-saga";
import cocoBulkPaymentRootSaga from "./coco-bulk-payment-root-saga";

export default function* rootSaga() {
  yield all([
    invoiceRootSaga(),
    loyaltyRootSaga(),
    schemeRootSaga(),
    couponRootSaga(),
    generalRootSaga(),
    customerRootSaga(),
    productRootSaga(),
    storeRootSaga(),
    storeViewWatcher(),
    authRootSaga(),
    userRootSaga(),
    adminCustomerRootSaga(),
    discountRootSaga(),
    inventoryRootSaga(),
    salesRootSaga(),
    purchaseRootSaga(),
    financialRootSaga(),
    settingsRootSaga(),
    doctorRootSaga(),
    reportRootSaga(),
    dashboardRootSaga(),
    stockAuditRootSaga(),
    alertRootSaga(),
    regionalRestrictionsRootSaga(),
    customReportRootSaga(),
    customFunctionRootSaga(),
    approvalWorkFlowRootSaga(),
    cocoBulkPaymentRootSaga(),
  ]);
}
